module.exports = __webpack_public_path__ + "img/166.67948ed3.jpg";